import { atom, useSetAtom } from 'jotai';

export const getMatchedModalOpenAtom = atom(false);

export const useOpenGetMatchedModal = () => {
    const setOpen = useSetAtom(getMatchedModalOpenAtom);
    return () => setOpen(true);
};
